var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "14",
        viewBox: "0 0 17 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2.57381 5.58365L0 9.99424V1.87528C0 0.850977 0.832788 0.0181885 1.85709 0.0181885H5.26659C5.75988 0.0181885 6.23285 0.212602 6.58106 0.560807L7.35001 1.32976C7.69821 1.67796 8.17119 1.87238 8.66448 1.87238H12.0711C13.0954 1.87238 13.9282 2.70516 13.9282 3.72946V4.65801H4.17845C3.51686 4.65801 2.9075 5.00911 2.57381 5.58075V5.58365ZM3.37468 6.05082C3.54298 5.76356 3.84766 5.58945 4.17845 5.58945H15.7853C16.1189 5.58945 16.4236 5.76646 16.589 6.05663C16.7544 6.3468 16.7544 6.70081 16.5861 6.98807L13.3362 12.5593C13.1708 12.8437 12.8661 13.0178 12.5353 13.0178H0.928544C0.594849 13.0178 0.29017 12.8408 0.124773 12.5506C-0.0406238 12.2605 -0.0406238 11.9065 0.127675 11.6192L3.37758 6.04792L3.37468 6.05082Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }